var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"dn-margin-1"},_vm._l((_vm.cards),function(card){return _c('InfoCard',{directives:[{name:"show",rawName:"v-show",value:(card.invisible),expression:"card.invisible"}],key:card.type,attrs:{"title":card.title},on:{"click":function($event){return _vm.oPage(card.type)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf57a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xxxz.vue
// module id = null
// module chunks = 